import { bindActionCreators } from 'redux';

export const MAIL_CHANGE = 'LOGINADMIN/MAIL_CHANGE';
export const PASS_CHANGE = 'LOGINADMIN/PASS_CHANGE';
export const ADMIN_LOGIN = 'LOGINADMIN/ADMIN_LOGIN';
export const MAIL_CHANGE_FORGOT_PASS = 'LOGINADMIN/MAIL_CHANGE_FORGOT_PASS';
export const CHANGE_PASS_REQ = 'LOGINADMIN/CHANGE_PASS_REQ';

export const mailChange = mail => ({
  type: MAIL_CHANGE,
  payload: { mail }
});

export const mailChangeForgotPass = mailForgot => ({
  type: MAIL_CHANGE_FORGOT_PASS,
  payload: { mailForgot }
});

export const changePassReq = mail => ({
  type: CHANGE_PASS_REQ,
  payload: { mail }
});

export const passChange = pass => ({
  type: PASS_CHANGE,
  payload: { pass }
});

export const adminLogin = callback => ({
  type: ADMIN_LOGIN,
  payload: { callback }
});

function containerActions(dispatch) {
  return bindActionCreators(
    {
      mailChange,
      passChange,
      adminLogin,
      mailChangeForgotPass,
      changePassReq
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/actions.js